export default __webpack_public_path__ + "static/media/grafema.7291dab7.png";